export const COEFFICIENTS = {
  age: 0.0370,
  sex: 0.1020,
  nstemi: 0.5249,
  eGFR: -0.0116,
  eGFRc2: 0.0158,
  hemo: -0.0109,
  albuminuriaMild: 0.0876,
  albuminuriaHEavy: 0.0246,
  charlsonCHF: 0.3610,
  charlsonCOPD: 0.2316,
  liverDis: 0.3608,
  charlsonPVD: 0.1231,
  diabetes: 0.0741,
  priorInv: -0.2424
};

export const BASELINES = {
  age: -77.14,
  eGFR: -51.41,
  hemo: -126.74
};

export const FACTOR = {
  conservativeMgmt: 1 / 0.87
};
